import React from 'react'
import { useSelector } from 'react-redux'

import ImageText from './imageText'
import AccordionList from './accordionList'
import Tabs from './tabs'
import TextFull from './textFull'
import VideoPlayer from './videoPlayer'
import Testimony from './testimony'
import SliderMedias from './sliderMedias'
import SliderKeyFigures from './sliderKeyFigures'
import SliderPartners from './sliderPartners'
import ImageSlice from './imageSlice'
import Flipbook from './flipbook'
import SliderOffers from './sliderOffers'
import Rates from './rates'
import Faq from '../contact/faq'
import slugify from 'slugify'

import trads from '../../intl/trads.json'

const SlicesWrapper = ({slices, isOffer= false, lang: propLang}) => {
  const storeLang = useSelector(state => state.lang)
  const lang = propLang || storeLang
  
  // render slices components based on content type
  const renderSlice = (slice, type) => {
    switch(type) {
      case 'ContentfulFullText':
        return (
          <TextFull data={slice} isOffer={isOffer} lang={lang} />
        )
      case 'ContentfulSliderOffers':
        return (
          <SliderOffers data={slice} lang={lang} />
        )
      case 'ContentfulSlicePdf':
        return (
          <Flipbook data={slice} />
        )
      case 'ContentfulVideo':
        return (
          <VideoPlayer data={slice} />
        )
      case 'ContentfulRates':
        return (
          <Rates data={slice} />
        )
      case 'ContentfulImageTexteSection':
        return (
          <ImageText data={slice} isOffer={isOffer} />
        )
      case 'ContentfulTestimony':
        return (
          <Testimony data={slice} isOffer={isOffer} />
        )
      case 'ContentfulSliderPartnersClients':
        return (
          <SliderPartners data={slice} isOffer={isOffer} />
        )
      case 'ContentfulSlider':
        return (
          <>
          { 
            slice.type === 'Medias' 
            ? <SliderMedias data={slice} isOffer={isOffer} />
            : 
            <>
              <SliderKeyFigures data={slice} isOffer={isOffer} />
            </>
          }
          </>
        )
      case 'ContentfulSliceImage':
        return (
          <ImageSlice data={slice} />
        )
      case 'ContentfulTabsaccordion':
        return (
          <>
            {slice.type === 'Accordion' 
            ? <AccordionList data={slice} />
            : <Tabs data={slice} /> }
          </>
        )
      case 'ContentfulFaqSet':
        return (
          <div className="col-12 lg-col-10 xl-col-8 mx-auto">
            <Faq data={slice} />
          </div>
        )
      default:
        return 'error';
    }
  }

  const previewContentType = (type) => {
    return `Contentful${type.charAt(0).toUpperCase() + type.slice(1)}`
  }

  return (
    <>
      { slices && slices.map((item, i) => { 
        let slice = (item.fields) ? item.fields : item
        let type = (item.fields) ? previewContentType(item.sys.contentType.sys.id) : item.internal.type
        let subtype = false
        let typesBgs = ['ContentfulTabsaccordion', 'ContentfulTestimony', 'ContentfulSlicePdf']

        if (type === 'ContentfulTabsaccordion') {
          if (slice.type === 'Accordion') {
            subtype = true
          }
        }

        if (type === 'ContentfulSlider') {
          if (slice.type !== 'Medias' && isOffer ) {
            typesBgs.push('ContentfulSlider')
          }
        }

        if (type === 'ContentfulImageTexteSection') {
          if (slice.themeSolutions && slice.themeSolutions.includes('Dégradé')) {
            typesBgs.push('ContentfulImageTexteSection')
          }
        }

        let anchorTitle = slice.title ? slice.title : slice.anchorTitle ? slice.anchorTitle : ''

        if (type === 'ContentfulRates') {
          anchorTitle = trads[lang].offers.rates
        }

        return (
          <section id={anchorTitle !== '' ? slugify(anchorTitle, {remove: /[*+~.,()'"!?:@,]/g}).toLowerCase() : ''} data-anchor={anchorTitle} className={`slice ${(typesBgs.indexOf(type) !== -1 && !subtype) ? 'slice--bg' : ''}`} key={i}>
            {renderSlice(slice, type)}
          </section>
        )
      }) }
    </>
  )
}

export default SlicesWrapper
